"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerSaraiva = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("date-fns");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));
var _dateFns2 = _interopRequireDefault(require("@date-io/date-fns"));
var _pickers = require("@material-ui/pickers");
var _format = _interopRequireDefault(require("date-fns/format"));
var _core = require("@material-ui/core");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable class-methods-use-this */

class LocalizedUtils extends _dateFns2.default {
  getCalendarHeaderText(date) {
    return (0, _format.default)(date, 'MMMM yyyy', {
      locale: _ptBR.default
    }).charAt(0).toUpperCase() + (0, _format.default)(date, 'MMMM yyyy', {
      locale: _ptBR.default
    }).slice(1);
  }
  getDatePickerHeaderText(date) {
    return (0, _format.default)(date, 'EEEEEE, dd MMMM', {
      locale: _ptBR.default
    }).charAt(0).toUpperCase() + (0, _format.default)(date, 'EEEEEE, dd MMMM', {
      locale: _ptBR.default
    }).slice(1);
  }
}
const useStyles = (0, _core.makeStyles)(() => ({
  input: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 10,
      '& input': {
        cursor: 'pointer'
      }
    },
    '& .MuiIconButton-root': {
      color: 'rgba(33, 37, 41, 1)'
    }
  },
  marginInput: {
    '& .MuiFormControl-marginNormal': {
      margin: 0
    }
  },
  calendar: {
    '& .MuiPickersCalendar-transitionContainer': {
      marginBottom: 4
    }
  }
}));
const DatePickerSaraiva = _ref => {
  let {
    error,
    disabled,
    label,
    helperText,
    value,
    onChange,
    size
  } = _ref;
  const classes = useStyles();
  const keyboardButtonRef = (0, _react.useRef)();
  const inputRef = (0, _react.useRef)();
  function onInputAdornmentRef(el) {
    if (!el) return;
    inputRef.current = el.parentNode.querySelector('input');
  }
  return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: LocalizedUtils,
    locale: _ptBR.default
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    justify: "space-around",
    className: classes.marginInput
  }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, {
    autoOk: true,
    views: ['year', 'month', 'date'],
    error: error,
    disabled: disabled,
    variant: "inline",
    inputVariant: "outlined",
    format: "dd/MM/yyyy",
    margin: "normal",
    id: "date-picker-inline",
    label: label,
    helperText: helperText,
    value: value,
    onChange: onChange,
    onClick: () => keyboardButtonRef.current.click(),
    onOpen: () => inputRef.current.blur(),
    KeyboardButtonProps: {
      'aria-label': 'change date',
      ref: keyboardButtonRef
    },
    rightArrowButtonProps: {
      style: {
        marginRight: 16
      }
    },
    leftArrowButtonProps: {
      style: {
        marginLeft: 16
      }
    },
    className: classes.input,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    },
    InputAdornmentProps: {
      ref: onInputAdornmentRef
    },
    PopoverProps: {
      className: classes.calendar
    }
  })));
};
exports.DatePickerSaraiva = DatePickerSaraiva;
DatePickerSaraiva.propTypes = {
  /**
   * Se true, o contorno do Input fica vermelho
   */
  error: _propTypes.default.bool,
  /**
   * Se true, o input fica desabilitado (cinza e sem poder ser acessado)
   */
  disabled: _propTypes.default.bool,
  /**
   * Label que fica como placeholder no input e que fica sobre o input ao ser selecionado
   */
  label: _propTypes.default.string,
  /**
   * Texto de auxilio que fica abaixo do input de select
   */
  helperText: _propTypes.default.string,
  /**
   * Valor selecionado da data
   */
  value: _propTypes.default.string.isRequired,
  /**
   * Funcao utilizada para selecionar o valor da data
   */
  onChange: _propTypes.default.func,
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
DatePickerSaraiva.defaultProps = {
  error: false,
  disabled: false,
  label: 'Escolha uma Data',
  helperText: '',
  onChange: null,
  size: 'md'
};